// src/pages/About.js
import React from 'react';
import Testimonial from '../components/Testimonial';
import { Link } from 'react-router-dom';

const About = () => {
  const img = (path) => process.env.PUBLIC_URL + path;

  return (
    <div className="boxed_wrapper ltr">

      {/* Page Title Section */}
      <section className="page-title centred pt_130 pb_150"
        style={{
          backgroundImage: `url(${img('/assets/images/banner/translation.jpg')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative'
        }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.4)',
          zIndex: 1
        }}></div>
        <div className="pattern-layer" style={{ position: 'relative', zIndex: 2 }}>
          <div className="pattern-1" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-64.png')})` }}></div>
          <div className="pattern-2" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-65.png')})` }}></div>
        </div>
        <div className="auto-container" style={{ position: 'relative', zIndex: 3 }}>
          <div className="content-box">
            <span className="sub-title-three" style={{ color: '#fff' }}>About Us</span>
            <h1 style={{ color: '#fff' }}>About Wications</h1>
            <p style={{ color: '#eaeaea' }}>
              Languages are more than just words—they are tools that connect cultures, build relationships, and open doors to global opportunities.
              We specialize in Sri Lankan and South Indian languages, ensuring every message resonates with authenticity.
            </p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-style-three pb_150 pt-5" style={{ background: '#fff' }}>
        <div className="auto-container pt-3">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12 image-column">
              <div className="image_block_five">
                <div className="image-box mr_80">
                  <figure className="image"><img src={img('/assets/images/resource/about-5.jpg')} alt="" /></figure>
                  <ul className="image-content clearfix">
                    <li>
                      <div className="icon"><img src={img('/assets/images/icons/icon-7.png')} alt="" /></div>
                      <h6>Manual Subtitle</h6>
                    </li>
                    <li className="load">
                      <div className="icon"><img src={img('/assets/images/icons/icon-8.png')} alt="" /></div>
                      <h6>Auto Translate</h6>
                    </li>
                    <li>
                      <div className="icon"><img src={img('/assets/images/icons/icon-9.png')} alt="" /></div>
                      <h6>Upload Texts</h6>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="content_block_four">
                <div className="content-box ml_40">
                  <div className="sec-title mb_25">
                    <span className="sub-title overlay-anim-white-bg">About Wications</span>
                    <h2>Precise & Culturally Rooted Translation Services</h2>
                  </div>
                  <div className="text-box mb_40">
                    <p>Wications is a professional translation company dedicated to bridging communication gaps across Sri Lanka and South India.
                      With a team of native linguists and cultural experts, we deliver high-quality, accurate translations in Sinhala, Tamil,
                      Malayalam, Kannada, Telugu, and more.</p>
                  </div>
                  <div className="inner-box">
                    <div className="single-item mb_40">
                      <div className="icon-box"><i className="icon-13"></i></div>
                      <h3>Regional Language Expertise</h3>
                      <p>Specialized in Sinhala, Tamil, Malayalam, Kannada, and Telugu—empowering brands to engage local audiences meaningfully.</p>
                    </div>
                    <div className="single-item">
                      <div className="icon-box"><i className="icon-14"></i></div>
                      <h3>Industry-Focused Solutions</h3>
                      <p>From legal documents to marketing, e-learning, and media—our multilingual services support a wide range of sectors.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Glance Section */}
      <section className="glance-section centred">
        <div className="auto-container">
          <div className="inner-container">
            <div className="pattern-layer">
              {[5, 6, 7, 8, 9].map((n, i) => (
                <div key={i} className={`pattern-${n - 4} ${n >= 7 ? 'rotate-me' : ''}`}
                  style={{ backgroundImage: `url(${img('/assets/images/shape/shape-' + n + '.png')})` }}></div>
              ))}
            </div>
            <div className="sec-title light mb_80">
              <span className="sub-title">Wications' Vision</span>
              <h2>Empowering Regional Voices <br />Through Expert Translations</h2>
              <p><strong>Wications</strong> is committed to delivering impactful, high-quality translations in Sri Lankan and South Indian languages
                including Sinhala, Tamil, Malayalam, Telugu, and Kannada. Our vision is to create seamless communication across cultures by making
                local languages accessible to global platforms.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Work Process Section */}
      <section className="working-style-three about-page centred pt_150 pb_120">
        <div className="pattern-layer">
          <div className="pattern-1 float-bob-y" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-39.png')})` }}></div>
          <div className="pattern-2 float-bob-y" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-31.png')})` }}></div>
        </div>
        <div className="auto-container">
          <div className="sec-title mb_55">
            <span className="sub-title overlay-anim-white-bg">How it Works</span>
            <h2>Work Process Steps</h2>
          </div>
          <div className="upper-box mb_50 p_relative">
            <div className="image-shape">
              <div className="shape-1" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-36.png')})` }}></div>
              <div className="shape-2 rotate-me" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-37.png')})` }}></div>
              <div className="shape-3 rotate-me" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-38.png')})` }}></div>
            </div>
            <div className="video-inner" style={{ backgroundImage: `url(${img('/assets/images/resource/video-2.jpg')})` }}></div>
          </div>
          <div className="row clearfix">
            {[{
              title: 'Step 1: Initial Consultation',
              text: 'Contact us with the details of your project, including the type of content, source and target languages, and any specific requirements.',
              icon: 'icon-10'
            }, {
              title: 'Step 2: Translation Process',
              text: 'We carefully translate your content, ensuring accuracy, cultural relevance, and adherence to your tone and style.',
              icon: 'icon-11'
            }, {
              title: 'Step 3: Delivery',
              text: 'We deliver your completed project on time in your preferred format, whether it’s a Word document, PDF, multimedia file, or any other format.',
              icon: 'icon-12'
            }].map((step, idx) => (
              <div key={idx} className="col-lg-4 col-md-6 col-sm-12 working-block">
                <div className="working-block-two">
                  <div className="inner-box">
                    <div className="shape" style={{ backgroundImage: `url(${img('/assets/images/shape/shape-19.png')})` }}></div>
                    <div className="icon-box"><i className={step.icon}></i></div>
                    <h3>{step.title}</h3>
                    <p>{step.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
    
        <Testimonial />

      {/* CTA Section */}
      <section className="cta-section">
        <div className="bg-color"></div>
        <div className="auto-container">
          <div className="inner-container">
            <div className="pattern-layer">
              {[23, 24, 25, 26].map(n => (
                <div key={n} className={`pattern-${n - 22} ${n !== 23 ? 'rotate-me' : ''}`} style={{ backgroundImage: `url(${img('/assets/images/shape/shape-' + n + '.png')})` }}></div>
              ))}
            </div>
            <div className="inner-box">
              <h2>Let’s Bridge the Language Gap – <br />Get Started Now</h2>
             <div className="btn-box pt-3">
              <Link to="/contact" className="theme-btn btn-one">Get Started</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;